import TimeRange from './timeRange'
import { ContextState } from '../redux/context/ContextState'

const initialGlobalState = {}

// @ts-ignore
export const tidewaysContextReducer = (globalState: ContextState = initialGlobalState, action) => {
    // @ts-ignore
    if (!PRODUCTION && action.type && action.type.substr(0, 2) !== '@@') {
        console.groupCollapsed('%cRedux Action: %c%s', 'color: gray', 'color: darkblue', action.type)

        console.info(action)

        console.groupEnd()
    }

    switch (action.type) {
        case 'TIDEWAYS_INIT':
            // TidewaysContext methods are bound to the original instance, so keep that instance in sync.
            action.tidewaysContext.router = action.router

            return {
                ...globalState,
                ...action.tidewaysContext,
            }
        case 'TIDEWAYS_ROUTE': {
            const { route } = action

            let service = route.parameters.s

            if (!service || service.length === 0) {
                service = globalState.service
            }

            let environment = route.parameters.env

            if (!environment || environment.length === 0) {
                environment = globalState.environment
            }

            //
            // Make sure the TidewaysContext instance is kept in sync
            // as just updating the globalState will not notify this instance
            //

            const range = TimeRange.fromParameters(route.parameters)

            globalState.setService(service)
            globalState.setEnvironment(environment)
            globalState.setRange(range)
            globalState.route = route

            const elements = document.getElementsByTagName('html')

            if (elements.length === 1) {
                const html = elements[0]
                const previousRouteClass = html.dataset.tidewaysRoute

                if (previousRouteClass) {
                    html.classList.remove(previousRouteClass)
                }

                html.classList.add(route.route)
                html.dataset.tidewaysRoute = route.route
            }

            return {
                ...globalState,
                route,
                range,
                service,
                environment,
            }
        }
    }

    return globalState
}
